import React, { useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';


export function PageWrapper(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  //
  // const renderedNotification = useMemo(() => {
  //   const notification = notifications[0];
  //   if (!notification) return null;
  //   if (notification.renderMethod === 'TOAST') {
  //     let toastText = notification?.props?.message || `Missing toast message`;
  //     if (notification.props.status) {
  //       toastText = `${notification.props.status}: ${toastText}`;
  //     }
  //     if (notification.props.trace) {
  //       toastText += `\nDetails: ${notification.props.trace}`;
  //     }
  //     return (
  //       <GpsToast
  //         openProp={true}
  //         text={toastText}
  //         {...notification.props}
  //         closeHandler={() => {
  //           log.devInfo(`Firing notification close handler`, notification);
  //           dispatch(NotificationActions.deQueueNotification(notification));
  //         }}
  //       />
  //     );
  //   }
  //   return null;
  // }, [notifications]);

  return (
    // @ts-ignore
    // <Header>
    //  {renderedNotification}
      <div >
        {/*<div className='flex flex-col items-center justify-around w-[25%]' >*/}
        {/*    <button onClick={(e) => navigate(`/login`)} >*/}
        {/*        Login*/}
        {/*    </button>*/}
        {/*    <button onClick={(e) => navigate(`/notHome`)} >*/}
        {/*        Not Home*/}
        {/*    </button>*/}
        {/*</div>*/}
        <Outlet />
      </div>
    // </Header>
  );
}
